module.exports = __webpack_public_path__ + "static/img/30009 (2).68fe993.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30009 (2).webp
// module id = 79J9
// module chunks = 14